export default {
    common: {
        title: 'Content AI',
        socialPlanner: 'Sociale Planner',
        blog: 'Blog',
        funnel: 'Funnel',
        website: 'Website',
        email: 'E-Mail',
        words: 'Woorden',
        variations: 'Variaties',
    },
};
